import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { SongPlayer } from "@/components/site/SongPlayer";
import { ViberButton } from "@/components/site/ViberButton";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import CarDetail from "@/pages/CarDetail";
import AuthCallback from "@/pages/AuthCallback";
import MyInquiries from "@/pages/MyInquiries";
import AdminDashboard from "@/pages/AdminDashboard";
import Contact from "@/pages/Contact";

function AppRouter() {
  const location = useLocation();
  // Detect session_id synchronously to avoid race conditions
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  const isHome = location.pathname === "/";
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/buy" element={<Catalog listingType="sale" />} />
        <Route path="/rent" element={<Catalog listingType="rent" />} />
        <Route path="/cars/:id" element={<CarDetail />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/my-inquiries" element={<MyInquiries />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
      <Footer />
      <ViberButton />
      {isHome && <SongPlayer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster theme="dark" position="top-right" toastOptions={{
            style: { background: "#121212", border: "1px solid rgba(201,162,75,0.3)", color: "#fff" }
          }} />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
